<progress-spinner *ngIf="isLoading || saveInprogress"></progress-spinner>
<div class="autoConfigure-container">
  <div class="modal-header">
    <div class="title">
      <span class="header">Auto-configure JMEP</span>
    </div>
    <div class="btn-group" (click)="closeModal()">
      <i class="mdi mdi-close close-icon"></i>
    </div>
  </div>
  <div class="discover-content">
    <div class="discover-description">
      Auto-configure allows you to override values on the JMEP during initial discovery. Enter a new value or use the
      existing value on the JMEP. Factory default values are shown for reference and may not be on the JMEP if it is not
      new.
    </div>
    <form novalidate #autoConfigureForm="ngForm">
      <div class="config-content" *ngIf="!isLoading">
        <div class="item-header">
          <div class="label-header">Item</div>
          <div class="default-text-header">Factory Default</div>
          <div class="newtext-header">New Value</div>
        </div>
        <div class="item-content">
          <div class="item-row">
            <div class="config-label">IP Address</div>
            <div class="default-text">{{factoryDefaultConfig.ipAddress}}</div>
            <div class="newtext">
              <mat-select
                name="ipAddress"
                class="option-list"
                [(ngModel)]="autoConfiguration.ipAddress"
                #ipAddressInput="ngModel"
                [disabled]="!hasReadWriteRole"
                [ngClass]="{'custom-val': autoConfiguration.ipAddress !== factoryDefaultOption}"
                (ngModelChange)="updateAutoConfigSelection()">
                <mat-option
                  *ngFor="let ips of ipOption"
                  [value]="ips.value">
                  {{ips.name}}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="item-row">
            <div class="config-label">ARP/NDP</div>
            <div class="default-text">{{factoryDefaultConfig.selectedARPOption}}</div>
            <div class="newtext">
              <mat-select name="arp"
                class="option-list"
                [disabled]="isDisabledAutoConfig()"
                [ngClass]="{'custom-val': autoConfiguration.selectedARPOption !== factoryDefaultOption}"
                [(ngModel)]="autoConfiguration.selectedARPOption">
                <mat-option
                  *ngFor="let arpOptions of ARPOptions"
                  [value]="arpOptions.value">
                    {{arpOptions.name}}
                  </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="item-row">
            <div class="config-label">VLAN to Terminate</div>
            <div class="default-text">{{factoryDefaultConfig.vlan}}</div>
            <div class="newtext control-group">
              <input
                matInput
                name="vlan"
                type="number"
                maxlength="4"
                class="control input-decor input-text text-40"
                placeholder="1 - 4095"
                [ngClass]="{'custom-val': autoConfiguration.vlan !== ''}"
                [disabled]="!hasReadWriteRole"
                [(ngModel)]="autoConfiguration.vlan"
                #vlanInput="ngModel"
                (ngModelChange)="validateVlanChange()"
              />
                <div class="error-text">
                  <mat-error *ngIf="vlanInput?.errors?.regex">Enter value between 1 - 4095</mat-error>
                </div>
            </div>
          </div>
          <div class="item-row">
            <div class="config-label">Timing Mode</div>
            <div class="default-text">{{factoryDefaultConfig.selectedModeOption}}</div>
            <div class="newtext">
              <mat-select
                name="timing"
                class="option-list"
                [ngClass]="{'custom-val': autoConfiguration.selectedModeOption !== factoryDefaultOption}"
                [(ngModel)]="autoConfiguration.selectedModeOption" [disabled]="!hasReadWriteRole">
                <mat-option
                  *ngFor="let syncMode of timingMode"
                  [value]="syncMode.value">
                    {{syncMode.name}}
                  </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="item-row">
            <div class="config-label">Mask LoS Pin</div>
            <div class="default-text">{{factoryDefaultConfig.enableLosPin}}</div>
            <div class="newtext">
              <mat-select name="maskLoSPin"
                class="option-list"
                [ngClass]="{'custom-val': autoConfiguration.enableLosPin !== factoryDefaultOption}"
                [(ngModel)]="autoConfiguration.enableLosPin" [disabled]="!hasReadWriteRole">
                <mat-option [value]="factoryDefaultOption">{{factoryDefaultOption}}</mat-option>
                <mat-option [value]="true">Enabled</mat-option>
                <mat-option [value]="false">Disabled</mat-option>
              </mat-select>
            </div>
          </div>
          <div class="item-row">
            <div class="config-label">Enable 802.3ah</div>
            <div class="default-text">{{factoryDefaultConfig.selectedDyingGaspOption}}</div>
            <div class="newtext">
              <mat-select name="dyingGasp"
                class="option-list"
                [ngClass]="{'custom-val': autoConfiguration.selectedDyingGaspOption !== factoryDefaultOption}"
                [(ngModel)]="autoConfiguration.selectedDyingGaspOption" [disabled]="!hasReadWriteRole">
                <mat-option
                  *ngFor="let dyingGaspOptions of dyingGaspOptions"
                  [value]="dyingGaspOptions.value">
                    {{dyingGaspOptions.name}}
                  </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="item-row">
            <div class="config-label">Enable Ping Response</div>
            <div class="default-text">{{factoryDefaultConfig.enablePingResponse}}</div>
            <div class="newtext">
              <mat-select name="enablePingResponse"
                class="option-list"
                [(ngModel)]="autoConfiguration.enablePingResponse"
                [ngClass]="{'custom-val': autoConfiguration.enablePingResponse !== factoryDefaultOption}"
                [disabled]="isDisabledAutoConfig()">
                <mat-option [value]="factoryDefaultOption">{{factoryDefaultOption}}</mat-option>
                <mat-option [value]="true">Enabled</mat-option>
                <mat-option [value]="false">Disabled</mat-option>
              </mat-select>
            </div>
          </div>
          <div class="item-row">
            <div class="config-label">Inline Loopback Equipment Interface</div>
            <div class="default-text">{{factoryDefaultConfig.equipmentInterface}}</div>
            <div class="newtext">
              <mat-select
                class="option-list"
                [(ngModel)]="autoConfiguration.equipmentInterface"
                [ngClass]="{'custom-val': autoConfiguration.equipmentInterface !== factoryDefaultOption}"
                [disabled]="!hasReadWriteRole" name="eq-interface">
                <mat-option
                  *ngFor="let interface of loopbackInterface"
                  [value]="interface.value">
                    {{interface.name}}
                  </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="item-row">
            <div class="config-label">Inline Loopback Network Interface</div>
            <div class="default-text">{{factoryDefaultConfig.networkInterface}}</div>
            <div class="newtext">
              <mat-select name="nw-interface"
                class="option-list"
                [(ngModel)]="autoConfiguration.networkInterface"
                [ngClass]="{'custom-val': autoConfiguration.networkInterface !== factoryDefaultOption}"
                [disabled]="!hasReadWriteRole">
                <mat-option
                  *ngFor="let interface of loopbackInterface"
                  [value]="interface.value">
                    {{interface.name}}
                  </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="item-row">
            <div class="config-label">Respond to VIAVI Hello</div>
            <div class="default-text">{{factoryDefaultConfig.enableViaviHello}}</div>
            <div class="newtext">
              <mat-select name="repondToViavi"
                class="option-list"
                [(ngModel)]="autoConfiguration.enableViaviHello"
                [ngClass]="{'custom-val': autoConfiguration.enableViaviHello !== factoryDefaultOption}"
                [disabled]="!hasReadWriteRole">
                <mat-option [value]="factoryDefaultOption">{{factoryDefaultOption}}</mat-option>
                <mat-option [value]="true">Enabled</mat-option>
                <mat-option [value]="false">Disabled</mat-option>
              </mat-select>
            </div>
          </div>
        </div>

      </div>
    </form>
    <div class="dialog-action-cont">
      <button class="mat-focus-indicator mat-flat-button mat-button-base"
        (click)="saveConfiguration()"
        [disabled]="!hasReadWriteRole || !form?.valid || !isConfigValueChanged()"
      >SAVE</button>
      <button class="plain-btn" (click)="closeModal()">CANCEL</button>
    </div>
  </div>
</div>
